import React from 'react';

import drawing from '../img/banner/drawing.svg';
import illustration from '../img/banner/illustration@2x.png';

export const Banner = React.memo(() => (
  <div id="banner" className="relative mt-[66px] h-[468px]">
    <div className="absolute inset-x-0 bottom-0 h-[178px] bg-neutral-950"></div>
    <div className="absolute inset-x-0 top-0 mx-auto h-[468px] max-w-[1260px] px-[20px]">
      <div
        className="relative flex size-full flex-col items-start justify-center overflow-hidden rounded-[40px] p-[60px]"
        style={{ background: `#FE7757 url(${drawing}) no-repeat right top` }}
      >
        <div className="absolute right-[-120px] top-[60px] hidden md:block lg:right-[-120px] lg:top-[50px]">
          <img src={illustration} alt="Illustration" className="h-[330px] lg:h-[368px]" />
        </div>
        <div className="max-w-[386px] lg:max-w-[486px]">
          <div
            className="mt-[32px] text-[30px] 
            font-bold leading-[40px]
            lg:text-[38px] lg:leading-[52px]"
          >
            Let your next AI request speed up your Frontend
          </div>
          <div className="font-regular mt-[12px] text-[17px] leading-[30px] text-neutral-900">
            Ask for a component or upload an image, and instantly receive ready-to-use code without lifting a finger.
          </div>
          <button
            className="my-[32px] h-[46px] rounded-full bg-black px-[30px] text-[16px] font-bold text-white transition-all duration-200 hover:bg-white hover:text-black hover:shadow-xl active:shadow-none sm:h-[50px]"
            style={{
              transition: 'background-color 0.5s ease-in-out',
            }}
            onClick={() => {
              window.open('https://app.webcrumbs.ai/', '_blank');
            }}
          >
            Go to Frontend AI
          </button>
        </div>
      </div>
    </div>
  </div>
));
